import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
} from 'react';
import * as dsTokens from '../../generated/tokens/tokens';

interface Props extends PropsWithChildren {
  tokens?: object;
}

const DSContext = createContext<typeof dsTokens | null>(null);

export function useDSContext() {
  const value = useContext(DSContext);
  if (!value) {
    throw new Error('useDSContext must be used within a DSProvider');
  }
  return value;
}

export const DSProvider = ({ children, tokens }: Props) => {
  const combinedTokens = useMemo(() => ({ ...dsTokens, ...tokens }), [tokens]);

  return (
    <DSContext.Provider value={combinedTokens}>{children}</DSContext.Provider>
  );
};
